import { useEffect, useMemo, useState } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getInterventionColumns } from './InterventionFields'
import Loading from '../../common/Loading'
import DocumentPreview from '../../document/DocumentPreview'
import Intervention from './Intervention'
import { Box } from '@mui/material'

const ListInterventions = () => {
  const [statusList, setStatusList] = useState([])
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  useEffect(() => {
    const loadData = async () => {
      try {
        const [statusListRes, customersRes] = await Promise.all([
          getObjectsWithFilter('status', { object: 'interventions' }),
          getObjectsWithFilter('customers', { company_id: user.company_id })
        ])
        setStatusList(Array.isArray(statusListRes.data) ? statusListRes.data : [])
        setCustomers(Array.isArray(customersRes.data?.customers) ? customersRes.data.customers : [])
      } catch (error) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }

    loadData()
  }, [user.company_id])

  const columns = useMemo(() => {
    if (!statusList.length || !customers.length) return []
    return getInterventionColumns({ statusList, customers })
  }, [statusList, customers])

  const objectFilter = useMemo(() => ({ company_id: user.company_id }), [user.company_id])

  const options = useMemo(
    () => ({
      objectType: 'interventions',
      accessRight: userRight,
      objectFilter: () => objectFilter,
      actions: {
        add: true,
        edit: true,
        editDisabled: (intervention) => intervention.status >= 90,
        view: true,
        delete: {
          message: "Voulez-vous vraiment supprimer l'intervention",
          field: 'intervention_number'
        }
      },
      isFilter: true,
      isExpand: true,

      expand: (row) => <DocumentPreview Component={Intervention} document={row} />,

      columns
    }),
    [userRight, objectFilter, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'interventions',
      title: 'Interventions',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListInterventions
